<template>
<div class="zhuanpudetail">
    <div style="width: 7.5rem; height: .2rem; background: #4a90e2;" v-if="showAndroid"></div>
    <div style="width: 7.5rem; height: .8rem; background: #4a90e2;" v-if="showPhoneXS"></div>
    <div class="zhuanpudetail-top">
        <div class="zp-nav">
            <img src="../../../static/images/home/left-white.png" class="left-white" @click="goHome()">
            <p v-if="hiddenAndroid" class="p1" @click="goPublishop()">再发一个</p>
            <p v-if="hiddenAndroid" class="p2" @click="goPublishneed()">编辑商铺</p>
        </div>

        <div class="constructionUp">
            <div id="activityDiv">
                <ul num="0" id="activityUl">

                   <li class="activityLi" v-for="(item,index) in shopList" :key="index" @touchstart.capture="touchStart($event,index)" @touchend.capture="touchEnd($event,index)" v-if="shopListBox == 1" @click.stop="goList(item.shop.id);">
                        <div class="li-box">
                            <dl>
                                <dt>
                                    <img :src="item.shop.imgs" :onerror="defaultImg" />
                                </dt>
                                <dd>
                                    <h3>{{item.shop.shopName}}</h3>
                                    <p>{{item.shop.monthly_rent}}{{item.shop.unit}}</p>
                                </dd>
                            </dl>
                            <div class="zd-div">
                                <p v-show="item.shop.top_end_time">{{item.shop.top_end_time}}/</p>
                                <p v-show="item.shop.show_flag == 1">上架中</p>
                                <p v-show="item.shop.show_flag == 0 || item.shop.show_flag == ''">下架中</p>
                                <div class="xj-btn" v-if="item.shop.show_flag == 1" @click.stop="shopXJFun(item.shop.id,index)"><img src="../../../static/images/home/xiajia-icon.png" alt="" />下架</div>
                                <div class="xj-btn" @click.stop="shopSJFun(item.shop.id,index)" v-else><img src="../../../static/images/home/xiajia-icon.png" alt="" />上架</div>
                            </div>
                        </div>
                    </li>

                    <li class="activityLi" style="width: 6.62rem;" v-for="(item,index) in shopList" :key="index" v-if="shopListBox == 0" @click.stop="goList(item.shop.id);">
                        <div class="li-box">
                            <dl>
                                <dt>
                                    <img :src="item.shop.imgs" :onerror="defaultImg" />
                                </dt>
                                <dd>
                                    <h3>{{item.shop.shopName}}</h3>
                                    <p>{{item.shop.monthly_rent}}{{item.shop.unit}}</p>
                                </dd>
                            </dl>
                            <div class="zd-div">
                                <p v-show="item.shop.top_end_time">{{item.shop.top_end_time}}/</p>
                                <p v-show="item.shop.show_flag == 1">上架中</p>
                                <p v-show="item.shop.show_flag == 0 || item.shop.show_flag == ''">下架中</p>
                                <div class="xj-btn" v-if="item.shop.show_flag == 1" @click.stop="shopXJFun(item.shop.id,index)"><img src="../../../static/images/home/xiajia-icon.png" alt="" />下架</div>
                                <div class="xj-btn" @click.stop="shopSJFun(item.shop.id,index)" v-else><img src="../../../static/images/home/xiajia-icon.png" alt="" />上架</div>
                            </div>
                        </div>
                    </li>

                </ul>
            </div>
        </div>
    </div>

    <!-- 推广报告 -->
    <div class="report">
        <div class="report-top">
            <p>推广报告</p>
            <ul>
                <li><i style="background: #498EE0;"></i>访客</li>
                <li><i style="background: #46cc11;"></i>电话</li>
                <li><i style="background: #f06f41;"></i>咨询</li>
            </ul>
        </div>
        <div v-show="showLine == 1">
            <div class="report-box">
                <div id="myChart"></div>
            </div>
            <div class="more-data">
                <ul>
                    <li class="li1" v-if="linePage == 1"><img src="../../../static/images/home/left-white-round.png" alt="" /></li>
                    <li class="li1" v-else @click="pageLineFun()"><img src="../../../static/images/home/left-bule-round.png" alt="" /></li>
                    <li class="li2" v-if="linePage == countNum"><img src="../../../static/images/home/right-white-round.png" alt="" /></li>
                    <li class="li2" @click="pageLineAddFun()" v-else><img src="../../../static/images/home/right-bule-round.png" alt="" /></li>
                </ul>
            </div>
        </div>
        <div v-show="showLine == 0">
            <div class="null-data-box">
                <img src="../../../static/images/home/null-data.png">
                <p>暂无数据</p>
            </div>
        </div>
        
        <dl>
            <dt>
                <img src="../../../static/images/home/fk-icon.png" alt="" />
                <span>访客清单</span>
            </dt>
            <dd>
                <ul>
                    <li v-for="(item,index) in seeMemberList">
                        <img :src="item" :onerror="defaultImg1" >
                    </li>
                </ul>
                <span>({{seeMemberCount}}人)</span>
            </dd>
            <p @click="gofklist(0)">点击查看<img src="../../../static/images/home/right-gray.png" alt="" /></p>
        </dl>
        <dl>
            <dt>
                <img src="../../../static/images/home/tui-icon.png" alt="" class="tui-icon" />
                <span>智能推荐</span>
            </dt>
            <dd>
                <ul>
                    <li v-for="(item,index) in recommendList">
                        <img :src="item" :onerror="defaultImg1" >
                    </li>
                </ul>
                <span>({{recommendCount}}人)</span>
            </dd>
            <p @click="gofklist(1)">点击查看<img src="../../../static/images/home/right-gray.png" alt="" /></p>
        </dl>

    </div>

    <!-- 如何快速提高出租速度？ -->
    <div class="service-wrap">
        <h3>如何快速提高出租速度？</h3>
        <div class="service-box">
            <dl>
                <i><img src="../../../static/images/home/sx-icon.png"></i>
                <dt>2小时内排序优先</dt>
                <dd @click="sxShow = true;">刷新</dd>
            </dl>
            <dl>
                <i><img src="../../../static/images/home/zd-icon.png" class="zd-icon"></i>
                <dt>极速转铺服务</dt>
                <dd @click="goBuymembe('2')">升级</dd>
            </dl>
            <dl>
                <i><img src="../../../static/images/home/gj-icon.png" class="gj-icon"></i>
                <dt>联系服务顾问</dt>
                <dd  @click="goMessageuser('0_6');">详情</dd>
            </dl>
        </div>
    </div>

    <!-- footer -->
    <div class="shopdetail-footer">
        
        <img :src="customer.image" alt="" class="consultant2-img" :onerror="defaultImg1" v-if="customer.image" />

        <img src="../../../static/images/shopDetail/consultant2.png" alt="" class="consultant2-img" v-else/>
        
        <ul>
            <li class="li1" @click="goMessageuser('0_2');">
                <img src="../../../static/images/shopDetail/footer1-icon.png" alt="" />
                <span>在线聊</span>
            </li>
            <li class="li2" @click="telPhone()">
                <img src="../../../static/images/shopDetail/footer2-icon.png" alt="" />
                <span>打电话</span>
            </li>
        </ul>
    </div>

    <!-- 下架商铺弹窗 -->
    <div class="popup-wrap" v-if="isPopupShow">
        <div class="popup-box">
            <h3>确定下架商铺</h3>
            <div class="cause-wrap">
                <p>原因：</p>
                <div class="cause-box" @click.stop="showCauseFun()">
                    <span>{{causeVal}}</span><i></i>
                    <ul v-if="showCause">
                        <li v-for="item in reasonList" @click.stop="causeValFun(item.value,item.id)">{{item.value}}</li>

                        <!-- @click.stop -->
                    </ul>
                </div>
            </div>
            <div class="popup-bottom">
                <p class="p1" @click="cancelBtn()">取消</p>
                <p @click="defineBtn();">确定</p>
            </div>
        </div>
    </div>

    <!-- 刷新商铺弹窗 -->
    <div class="popup-wrap" v-if="sxShow">
        <div class="popup-box" style="height: 3.1rem;">
            <h3>确定刷新商铺</h3>
            <h5>让商铺排名靠前，获得更多咨询机会</h5>
            <div class="popup-bottom">
                <p class="p1" @click="sxShow = false">取消</p>
                <p @click="defineSxFun()">确定</p>
            </div>
        </div>
    </div>


</div>
</template>
<script>
import $ from '../../../static/js/jquery.min.js';
import axios from 'axios';
import qs from 'qs';

export default {
    name: 'zhuanpudetail',
    data () {
        return {

            shopList: [], //商铺列表

            liWidth: 0,
            liNum: 0,
            startX: 0,
            endX: 0,
            currantIndex: 0,
            test: false,

            lineList: [], //折线图
            seeMemberList: [], //访客清单
            recommendList: [], //

            recommendCount: "", //智能推荐人数
            seeMemberCount: "", //访客清单人数

            isPopupShow: false, //下架商铺弹窗
            sxShow: false, //刷新
            showCause: false,

            reasonList: [], //下架原因

            causeVal: "请选择",
            causeId: "",

            xjshopId: "", //下架id
            xjIndex: "",

            showLine: 1, //是否出现折线图

            countNum: "",

            linePage: 1,

            shopId: "",
            appType: "", //app类型
            ryUserId: "", //融云id
            cityId: "",

            customer: "", //顾问信息

            showBox: 1, 

            showPhoneXS: false,

            shopListBox: 1,

            defaultImg: 'this.src="' + require("../../../static/images/lookShop/err.png") + '"',

            defaultImg1: 'this.src="' + require("../../../static/images/shopDetail/consultant2.png") + '"',

            showAndroid: false,
            
            hiddenAndroid: true

            
        }
    },

    computed:{

    },
    updated(){

    },
    methods:{
        
        // 跳转商铺详情
        goList(id){
            // alert(id);
            if(this.appType == "ios"){
                window.location.href = "shopId:" + id;
            }else{
                return AndroidDial.showToast(id);
            }
        },

        defineSxFun(){
            let _this = this
            let url = _this.changeData() + '/transfer/updateTop'
            axios(url,{
                method: 'post',
                params:{
                    // shopId: 274098, //市 id
                    id: _this.shopId, //市 id
                    // id: 42343
                }
            }).then(data => {
                console.log(data);

                if(data.data.code == "101"){
                    layer.open({
                        content: "刷新成功",
                        skin: "msg",
                        time: 2 //2秒后自动关闭
                    });
                    this.sxShow = false;
                }else{
                    layer.open({
                        content: data.data.message,
                        skin: "msg",
                        time: 2 //2秒后自动关闭
                    });
                    this.sxShow = false;
                }

            }).catch(err => {
                console.log(err)
            });

        },

        // 跳转IM
        goMessageuser(typeId){
            
            let _this = this;

            let url = _this.changeData() + '/message/sendCustomeTipsOrShop'
            axios(url,{
                method: 'post',
                params:{
                    senderId: this.ryUserId, //发送人ID
                    targetIds: this.customer.id, //接收人ID
                    shopId: this.shopId, //商铺ID
                    type: typeId,
                    // source: "1",//  string  是   触发来源 1：详情 2：推荐
                }
            }).then(data => {

                console.log(data);
                 
            }).catch(err => {
                console.log(err)
            });

            if(this.appType == "ios"){
                window.webkit.messageHandlers.currentCookies.postMessage({
                    "body": "buttonActionMessage"
                });
            }else{
                return AndroidDial.showToast("1");
            }
        },
        
        // 拨打电话
        telPhone(){

            if(this.appType == "ios"){
                window.location.href = "tel:" + this.customer.phone;
            }else{
                // 2 是拨打电话
                return AndroidDial.showToast("2");
            }

        },

        // 再发一个
        goPublishop(){
            // this.$router.push({path:"/publishop"});
            if(this.appType == "ios"){

                this.$router.push({path:"/publishop", query:{app: "ios", userId: this.ryUserId, cityId: this.cityId, paramPhone: this.paramPhone}});

            }else{

                 this.$router.push({path:"/publishop", query:{app: "android", userId: this.ryUserId, cityId: this.cityId, paramPhone: this.paramPhone}});

            }
        },

        // 编辑需求
        goPublishneed(){

            if(this.appType == "ios"){
                this.$router.push({path:"/editshop", query:{app: "ios", userId: this.ryUserId, cityId: this.cityId, paramPhone: this.paramPhone, shopId: this.shopId}});
            }else{

                this.$router.push({path:"/editshop", query:{app: "android", userId: this.ryUserId, cityId: this.cityId, paramPhone: this.paramPhone, shopId: this.shopId}});

            }

        },

        // 上架操作
        shopSJFun(id,index){
            let _this = this
            let url = _this.changeData() + '/receive/updateSwitch';
            axios(url,{
                method: 'post',
                params:{
                    shopId: id, //商铺id
                    status: 1, // 0-下架 1-上架
                    reason: "", //下架原因，上架时不需要传
                    id: this.ryUserId
                }
            }).then(data => {
                console.log(data);                    

                if(data.data.code == '101'){
                    layer.open({
                        content: "上架成功",
                        skin: "msg",
                        time: 2 //2秒后自动关闭
                    });
                    this.shopList[index].shop.show_flag = 1;
                }else{
                		var message = data.data.message;
                    layer.open({
                        content: message,
                        skin: "msg",
                        time: 2 //2秒后自动关闭
                    });
                }
            }).catch(err => {
                console.log(err)
            });  
        },

        // 下架操作
        shopXJFun(id,index){
            this.isPopupShow = true;
            this.xjshopId = id;
            this.xjIndex = index;
        },

        showCauseFun(){
            this.showCause = true;
        },

        causeValFun(val,id){
            this.showCause = false;
            this.causeVal = val;
            this.causeId = id;
        },

        // 确定下架
        defineBtn(){
            // alert(1);
            let _this = this;
            if(this.causeId == ""){
                layer.open({
                    content: "请选择下架原因",
                    skin: "msg",
                    time: 2 //2秒后自动关闭
                });
            }else{
                let url = _this.changeData() + '/receive/updateSwitch';
                axios(url,{
                    method: 'post',
                    params:{
                        shopId: this.xjshopId, //商铺id
                        status: 0, // 0-下架 1-上架
                        reason: this.causeId, //下架原因，上架时不需要传
                        id: this.ryUserId
                    }
                }).then(data => {
                    console.log(data); 
                    if(data.data.code == '101'){
                        layer.open({
                            content: "下架成功",
                            skin: "msg",
                            time: 2 //2秒后自动关闭
                        });
                        this.shopList[this.xjIndex].shop.show_flag = 0;
                        this.isPopupShow = false;
                        this.causeId = "";
                        this.causeVal = "请选择";
                    }else{
                        layer.open({
                            content: "系统错误",
                            skin: "msg",
                            time: 2 //2秒后自动关闭
                        });
                    }
                }).catch(err => {
                    console.log(err)
                });

            }  
        },

        // 取消下架
        cancelBtn(){
            this.isPopupShow = false;
            this.causeId = "";
            this.causeVal = "请选择";
        },        

        // 初始数据
        listData() {
            let _this = this
            let url = _this.changeData() + '/transfer/detailList'
            axios(url,{
                method: 'post',
                params:{
                    // shopId: 274098, //市 id
                    shopId: _this.shopId, //市 id
                    // id: 42343,
                    id: this.ryUserId
                }
            }).then(data => {
                console.log(data);

                this.shopList = data.data.data;

                if(this.shopList.length == 1){
                    this.shopListBox = 0;
                }else{
                    this.shopListBox = 1;
                }


                this.customer = data.data.data[0].customer;

                console.log(this.customer);

                this.reasonList = data.data.reason; //下架原因

                console.log(this.reasonList);


                setTimeout(function () {
                    _this.initUlWidth();
                    _this.shopData();
                    _this.linechart();//租金趋势折线图
                },10);

                 
            }).catch(err => {
                console.log(err)
            });
        },

        initUlWidth () { // 初始化 ul的宽度
            let pit = document.documentElement.clientWidth / 750 // 当前手机屏幕和750屏幕的比例
            let oldWidth = document.getElementsByClassName('activityLi')[0].offsetWidth // 单个li的宽度

            console.log(oldWidth);

            let marginR = getComputedStyle(document.getElementsByClassName('activityLi')[0], null)['marginRight'] // 获取单个的marginRight,带px

            let marginNum = parseInt(marginR.replace('px', ''))
            this.liWidth = oldWidth + marginNum // 单个宽度+maringRight
            let liCount = parseInt(document.getElementsByClassName('activityLi').length)// li的个数
            this.liNum = liCount
            let ULpx = oldWidth * liCount + (liCount - 1) * marginNum // 最后一个margin不算
            document.getElementById('activityUl').style.width = ULpx / pit + 'px'// 除以比率，让当前div宽度与2倍设计比例一样，设置ul的长度最后那个margin不算
        },
        touchStart (e,index) {
            let _this = this;
            //记录初始位置
            // e.preventDefault() // 阻止默认事件，滚动等
            this.startX = e.touches[0].clientX // 记录滑动开始的位置
        },
        touchEnd (e,index) {
            let _this = this;
            var indexNum = index;

            // e.preventDefault() // 阻止默认事件

            // 记录结束位置
            this.endX = e.changedTouches[0].clientX
            // 左滑
            if (this.startX - this.endX > 40) {
                // console.log('左滑')
                if (this.currantIndex >= this.liNum - 1) {
                    // 不做操作
                } else {

                    _this.shopList.forEach(function (item, index) {
                        if(index == indexNum + 1){
                            _this.shopId = item.shop.id; //商铺id
                            // console.log(_this.shopId);
                            _this.linePage = 1;
                            _this.shopData();
                        }
                    });

                    this.currantIndex++
                    document.getElementById('activityUl').style.left = -this.currantIndex * this.liWidth + 'px'
                }
            }
            // 右滑
            if (this.startX - this.endX < -40) {
                if (this.currantIndex === 0) {
                    console.log('右滑')
                    // 不做操作
                } else {
                    console.log('右滑1');
                    _this.shopList.forEach(function (item, index) {
                        if(index == indexNum - 1){
                            _this.shopId = item.shop.id; //商铺id
                            // console.log(_this.shopId);
                            _this.linePage = 1;
                            _this.shopData();
                            _this.linechart();
                        }
                    });
                    
                    this.currantIndex--;
                    document.getElementById('activityUl').style.left = -this.currantIndex * this.liWidth + 'px'
                }
            }
            this.startX = 0
            this.endX = 0
        },

        linechart(){
            var dateNum = []; //日期

            var seeCount = []; //查看数量
            var calCount = []; //电话数量
            var askCount = []; //咨询数量


            this.lineList.forEach(function (item,index) {

                dateNum.push(item.time); //日期
                seeCount.push(item.see_count); //查看数量
                calCount.push(item.cal_count); //电话数量
                askCount.push(item.ask_count); //咨询数量

            })
            // 基于准备好的dom，初始化echarts实例
            var myChart = this.$echarts.init(document.getElementById("myChart"))
            // 绘制图表
            myChart.setOption({
                color: ["#498EE0","#46CC11","#F06F41"],
                tooltip: {
                    // formatter: function (param) { //修改点击后的提示信息}
                },
                grid: {
                    x: 40,
                    y: 25,
                    x2: 15,
                    y2: 30 //距离下边的距离
                },
                xAxis: {
                    type: 'category',
                    data: dateNum
                    // data:  ['5-20', '5-21', '5-22', '5-23', '5-24', '5-25', '5-26']
                    // data: ['12.20', '12.21', '12.22', '12.23', '12.24', '12.25', '12.26']
                },
                yAxis: {
                    type: 'value',
                },

                series: [{
                    name: '访客',
                    type: 'line',
                    symbolSize: 5,
                    areaStyle: { 
                        color: "#f4f4f4",
                        opacity: 0,
                        symbolSize: 1,
                    },
                    data: seeCount
                },{
                    name: '电话',
                    type: 'line',
                    symbolSize: 5,
                    areaStyle: { 
                        color: "#f4f4f4",
                        opacity: 0,
                        symbolSize: 1,
                    },
                    data: calCount
                },{
                   name: '咨询',
                    type: 'line',
                    symbolSize: 5,
                    areaStyle: { 
                        color: "#f4f4f4",
                        opacity: 0,
                        symbolSize: 1,
                    },
                    data: askCount
                },             
            ],
            dataZoom: [
                {   // 这个dataZoom组件，也控制x轴。
                  type: 'inside', // 这个 dataZoom 组件是 inside 型 dataZoom 组件
                  start: 0,      // 左边在 10% 的位置。
                  end: 50         // 右边在 60% 的位置。
                }
              ],
            });
        }, 

        // 返回首页
        goHome(){
            // this.$router.push({path:"/home"});
            if(this.appType == "ios"){
                // alert(1);
                window.webkit.messageHandlers.currentCookiesBack.postMessage({
                    "body": "buttonActionMessage"
                });
            }else{
                return AndroidDial.showToast("3");
            }
        },

        // 去访客列表
        gofklist(type){
            // this.$router.push({path:"/fklist", query:{shopid:this.shopId,type:type}});
            if(this.appType == 'ios'){
                this.$router.push({path:"/fklist", query:{app: "ios", userId: this.ryUserId, cityId: this.cityId, paramPhone: this.paramPhone, shopId:this.shopId, type:type}});
            }else{
                this.$router.push({path:"/fklist", query:{app: "android", userId: this.ryUserId, cityId: this.cityId, paramPhone: this.paramPhone, shopId:this.shopId, type:type}});
            }            
        },

        // 初始数据
        shopData(){
            let _this = this
            let url = _this.changeData() + '/transfer/getDetailTable'
            axios(url,{
                method: 'post',
                params:{
                    shopId: _this.shopId//市 id
                }
            }).then(data => {
                // console.log(data);
                // this.shopList = data.data.data;

                this.lineList = data.data.data.list; //折线图
                this.seeMemberList = data.data.data.seeMember.img; //访客清单
                this.seeMemberCount = data.data.data.seeMember.count; //访客清单人数
                this.recommendList = data.data.data.recommend.img; //智能推荐
                this.recommendCount = data.data.data.recommend.count; //智能推荐人数
                this.countNum = Math.ceil(data.data.count / 7); //总数

                if(this.lineList.length == 0){
                    this.showLine = 0;
                }else{
                    this.showLine = 1;
                }
                _this.linechart();   
            }).catch(err => {
                console.log(err)
            });
        },
        
        // 加
        pageLineAddFun(){
            let _this = this;
            this.linePage = this.linePage+1;
            let url = _this.changeData() + '/transfer/tableJson'
            axios(url,{
                method: 'post',
                params:{
                    id: _this.shopId,//市 id
                    pageNum: this.linePage
                }
            }).then(data => {
                // console.log(data);
                this.lineList = data.data.data; //折线图
                _this.linechart();  
            }).catch(err => {
                console.log(err)
            });
        },

        // 减
        pageLineFun(){
            let _this = this;
            _this.linePage = this.linePage - 1;
            let url = _this.changeData() + '/transfer/tableJson'
            axios(url,{
                method: 'post',
                params:{
                    id: _this.shopId,//市 id
                    pageNum: this.linePage
                }
            }).then(data => {
                // console.log(data);
                this.lineList = data.data.data; //折线图
                 _this.linechart();  
            }).catch(err => {
                console.log(err)
            });
        },

        goBuymembe(typeId){
            // this.$router.push({path:"/buymember",query:{zhuanpudetail:1}});
            if(this.appType == "ios"){

                // window.webkit.messageHandlers.currentCookiesBuy.postMessage({
                //     "body": "buttonActionMessage"
                // });

                window.location.href = "type:" + typeId;

            }else{
                if(typeId == '2'){
                    return AndroidDial.showToast("4");
                }else{
                    return AndroidDial.showToast("5");
                }
            }
        },

    },
    mounted() {

        this.appType = this.$route.query.app;

        this.ryUserId = this.$route.query.userId;

        this.shopId = this.$route.query.shopId;

        this.cityId = this.$route.query.cityId;

        this.paramPhone = this.$route.query.paramPhone;

        this.listData();


        // iPhone X、iPhone XS
        var isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;
        // iPhone XS Max
        var isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;
        // iPhone XR
        var isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;

        if(this.appType == "ios"){
            if(isIPhoneX || isIPhoneXSMax || isIPhoneXR){
                this.showPhoneXS = true;
            }
        }

        if(this.appType == "android"){
            this.showAndroid = true;
        }
        
        if(this.appType == "android"){
            this.hiddenAndroid = false;
        }

        if(this.shopId){
            // alert(1);
            this.shopData();
        }

    },
    created() { 

       
    }
}
</script>


<style scoped lang="scss">

.zhuanpudetail{
    width: 7.5rem;
    background: #fff;
}

.zhuanpudetail-top{
    width: 7.5rem;
    width: 100%;
    height: 3.9rem;
    background: #fff!important;
    position: relative;
    .zp-nav{
        width: 7.5rem;
        height: 2.44rem;
        background: #4a90e2;
        position: relative;
        .left-white{
            width: .2rem;
            height: .33rem;
            padding: .4rem;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
        }
        p{
            font-size: .28rem;
            font-weight: 500;
            color: #fff;
            line-height: .4rem;
        }
        .p1{
            position: absolute;
            right: 1.8rem;
            top: .4rem;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
        }
        .p2{
            position: absolute;
            right: .4rem;
            top: .4rem;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
        }
    }
}

/* 轮播图 */
.constructionUp{
    width: 100%;
    position: absolute;
    left: 0;
    top: 1.33rem;
    #activityDiv{
        padding-left: 0.4rem;
        overflow: hidden;
        #activityUl{
            position: relative;
            left: 0;
            height: 2.56rem;
            transition:all .35s ease-in-out;
            .activityLi{
                float: left;
                width: 6.32rem;
                /*width: 6.6rem;*/
                height: 2.56rem;
                background: #fff;
                border-radius: 8px;
                border: 1px solid rgba(0,0,0,0.05);
                &:not(:last-child){
                    margin-right: 0.4rem;
                }
                .li-box{
                    padding: .3rem;
                    dl{
                        width: 5.7rem;
                        height: 1.44rem;
                        dt{
                            width: 1.92rem;
                            height: 1.44rem;
                            border-radius: 6px;
                            float: left;
                            img{
                                width: 100%;
                                height: 100%;
                                border-radius: 6px;
                            }
                        }
                        dd{
                            width: 3.6rem;
                            height: 1.44rem;
                            float: right;
                            position: relative;
                            h3{
                                width: 3.6rem;
                                font-size: .3rem;
                                font-weight: 500;
                                color: #333;
                                line-height: .46rem;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                            p{
                                font-size: .3rem;
                                font-weight:600;
                                color: #de4b4f;
                                line-height: .36rem;
                                position: absolute;
                                bottom: 0;
                                left: 0;
                            }
                        }
                    }
                    .zd-div{
                        position: relative;
                        p{
                            font-size: .22rem;
                            font-weight: 400;
                            color: #666;
                            line-height: .46rem;
                            float: left;
                            margin-top: .14rem;
                            display: inline-block;
                        }
                        .xj-btn{
                            width: 1.24rem;
                            height: .54rem;
                            background: #4a90e2;
                            border-radius: 6px;
                            text-align: center;
                            font-size: .24rem;
                            font-weight: 500;
                            color: #fff;
                            line-height: .36rem;
                            float: right;
                            line-height: .54rem;
                            margin-top: .1rem;
                            -webkit-tap-highlight-color: rgba(0,0,0,0);
                            img{
                                width: .26rem;
                                height: .26rem;
                                position: relative;
                                left: -.02rem;
                                top: -.01rem;
                            }
                        }
                    }
                }
            }
        }
    }
}

/* 推广报告 */
.report{
    width: 6.7rem;
    margin: 0 auto;
    .report-top{
        width: 6.7rem;
        height: .8rem;
        padding-top: .48rem;
        p{
            font-size: .36rem;
            font-weight: 500;
            color: #333;
            line-height: .5rem;
            float: left;
        }
        ul{
            float: right;
            li{
                display: inline-block;
                font-size: .22rem;
                font-weight:400;
                color: #333;
                line-height: .3rem;
                margin-left: .3rem;
                i{
                    display: inline-block;
                    width: .13rem;
                    height: .13rem;
                    border-radius: 50%;
                    margin-right: .16rem;
                }
            }
        }
    }
    dl{
        width: 6.7rem;
        padding: .3rem 0;
        border-bottom: 1px solid #f2f2f2;
        position: relative;
        dt{
            display: inline-block;
            img{
                width: .29rem;
                height: .33rem;
            }
            .tui-icon{
                width: .33rem;
                height: .27rem;
            }
            span{
                font-size: .22rem;
                font-weight: 500;
                color: #333;
                line-height: .3rem;
            }
        }
        dd{
            display: inline-block;
            ul{
                position: relative;
                top: .1rem;
                left: 0px;
                display: inline-block;
                margin-left: .3rem;
                margin-right: .2rem;
                li{
                    width: .4rem;
                    height: .4rem;
                    border-radius: 50%;
                    display: inline-block;
                    border: 1px solid rgba(255,255,255,1);
                    float: left;
                    img{
                        width: .4rem;
                        height: .4rem;
                        border-radius: 50%;
                    }
                }
            }
            span{
                font-size: .22rem;
                font-weight: 500;
                color: #333;
                line-height: .3rem;
            }
        }
        p{
            display: inline-block;
            font-size: .22rem;
            font-weight: 500;
            color: #4a90e2;
            line-height: .3rem;
            position: absolute;
            right: 0;
            top: .5rem;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            img{
                width: .12rem;
                height: .2rem;
                margin-left: .16rem;
                position: relative;
                top: -.01rem;
                left: 0;
            }
        }
    }
}
/* echarts */
.report-box{
    width: 6.7rem;
    height: 3.5rem;
    /*background: #f4f4f4;*/
    border-radius: 4px;
    margin: 0 auto;
}
.more-data{
    width: 6.7rem;
    padding-top: .18rem;
    height: .7rem;
    ul{
        width: 1.4rem;
        margin: 0 auto;
        li{
            width: .52rem;
            height: .52rem;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            img{
                width: .52rem;
                height: .52rem;
            }
        }
        .li1{
            float: left;
        }
        .li2{
            float: right;
        }
    }
}

.service-wrap{
    width: 6.7rem;
    margin: 0 auto;
    padding: .6rem 0 2.5rem;
    h3{
        font-size: .34rem;
        font-weight: 500;
        color: #333;
        line-height: .48rem;
        margin-bottom: .3rem;
    }
    .service-box{
        width: 6.7rem;
        box-shadow: 0px 10px 62px 3px rgba(0,0,0,0.05);
        border-radius: 8px;
        border: 1px solid #e0e0e0;
        dl{
            width: 6.7rem;
            height: .6rem;
            padding: .4rem 0;
            border-bottom: 1px solid #f4f4f4;
            position: relative;
            i{
                display: inline-block;
                width: .42rem;
                margin: 0 .4rem;
                img{
                    width: .36rem;
                    height: .38rem;
                }
                .zd-icon{
                    width: .42rem;
                    height: .36rem;
                }
                .gj-icon{
                    width: .35rem;
                    height: .35rem;
                }
            }
           
            dt{
                font-size: .26rem;
                font-family: PingFangSC-Medium,PingFang SC;
                font-weight: 500;
                color: #333;
                line-height: .6rem;
                display: inline-block;
            }
            dd{
                width: 1.5rem;
                height: .6rem;
                background: #4a90e2;
                border-radius: 6px;
                display: inline-block;
                font-size: .26rem;
                font-weight: 400;
                color: #fff;
                line-height: .6rem;
                text-align: center;
                -webkit-tap-highlight-color: rgba(0,0,0,0);
                position: absolute;
                right: .4rem;
                top: .4rem;
            }
        }
    }
}

/* footer */
.shopdetail-footer{
    width: 6.5rem;
    padding: 0 .5rem;
    height: 1.68rem;
    background: #fff;
    position: fixed;
    left: auto;
    bottom: 0;
    border-bottom: 2px solid #f8f8f8;
    z-index: 1000;
    .consultant2-img{
        width: 1.58rem;
        height: 1.58rem;
        position: relative;
        left: 0;
        top: -.4rem;
        border-radius: 50%;
    }
    ul{
        float: right;
        margin-top: .2rem;
        li{
            width: 2.24rem;
            float: left;
            text-align: center;
            line-height: .8rem;
            font-size: .32rem;
            font-weight: 400;
            color: #fff;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            img{
                width: .36rem;
                height: .36rem;
            }
        }
        .li1{
            background: url("../../../static/images/shopDetail/footer1.png") no-repeat;
            background-size: 2.24rem .86rem;
        }
        .li2{
            background: url("../../../static/images/shopDetail/footer2.png") no-repeat;
            background-size: 2.24rem .86rem;
        }
    }
}

#myChart{
    width: 6.7rem!important;
    height: 3.4rem!important;
}

/* 弹窗 */
.popup-wrap {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    .popup-box {
        width: 5.4rem;
        height: 3.5rem;
        background: #fff;
        position: absolute;
        left: 50%;
        top: 30%;
        margin-left: -2.7rem;
        border-radius: 10px;
        h3 {
            color: #333;
            font-size: 0.34rem;
            text-align: center;
            margin-top: 0.3rem;
            margin-bottom: 0.2rem;
        }
        h5{
            font-size: .28rem;
            font-weight: 400;
            color: #333;
            line-height: .8rem;
            text-align: center;
        }
        .cause-wrap{
            margin-top: .36rem;
            margin-left: .58rem;
            p{
                font-size: .28rem;
                font-weight: 400;
                color: #333;
                line-height: .7rem;
                float: left;
            }
            .cause-box{
                width: 3.3rem;
                height: .7rem;
                background: #fafafa;
                border-radius: 6px;
                border: 1px solid #e7e7e7;
                float: left;
                text-align: center;
                position: relative;
                z-index: 9;
                span{
                    display: inline-block;
                    font-size: .28rem;
                    font-weight: 400;
                    color: #333;
                    line-height: .7rem;
                }
                i{
                    display: inline-block;
                    width: 0px;               
                    height: 0px;
                    border: 6px solid #666;
                    border-bottom-color: transparent;
                    border-left-color: transparent;
                    border-right-color: transparent;
                    position: absolute;
                    right: .3rem;
                    top: .3rem;
                }
                ul{
                    position: relative;
                    left: 0px;
                    bottom: -0rem;
                    width: 3.3rem;
                    background: #fff;
                    border: 1px solid #e7e7e7;
                    border-radius: 6px;
                    li{
                        font-size: .28rem;
                        font-weight: 400;
                        color: #333;
                        height: .8rem;
                        text-align: center;
                        line-height: .8rem;
                    }
                }
            }
        }
        .popup-bottom{
            width: 100%;
            padding: .3rem 0;
            height: 0.4rem;
            border-top: 1px solid #e8e8e8;
            position: absolute;
            bottom: 0;
            left: 0;
            p{
                width: 50%;
                float: left;
                color: #fff;
                font-size: 0.3rem;
                text-align: center;
                color: #4a90e2;
                line-height: .4rem;
            }
            .p1 {
                color: #999;
                border-right: 1px solid #e8e8e8;
                box-sizing: border-box;
            }
        }
    }
}

/*无数据*/
.null-data-box{
    text-align: center;
    margin: .8rem 0;
    img{
        width: 1.6rem;
        height: 1.6rem;
    }
    p{
        font-size: .28rem;
        font-weight: 400;
        color: #999;
        line-height: .4rem;
        margin-top: .24rem;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/home/zhuanpudetail.vue